module.exports = __webpack_public_path__ + "img/success.017a43e8.svg";